import { render, staticRenderFns } from "./StakeDialog.vue?vue&type=template&id=13883dd6&scoped=true&"
import script from "./StakeDialog.vue?vue&type=script&lang=js&"
export * from "./StakeDialog.vue?vue&type=script&lang=js&"
import style0 from "./StakeDialog.vue?vue&type=style&index=0&id=13883dd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13883dd6",
  null
  
)

export default component.exports